import React from 'react';
import { Link } from '@vtblife/uikit';
import { useLkLinks } from '@search/classified-common/src/SaveSearch/useLkLinks';
import { SuccessModal } from '../../../SuccessModal/SuccessModal';

type Props = {
    onClose: () => void;
}

export const SubscribeToPriceSuccessModal = ({ onClose }: Props) => {
    const { savedSearchUrl } = useLkLinks();

    return (
        <SuccessModal
            mobileDescription={
                <>
                    Уведомления об&nbsp;изменениях цены подключены. Управлять уведомлениями можно в&nbsp;разделе
                    <Link variant='primary-minor' href={savedSearchUrl} target='blank'>&laquo;Подписки&raquo;</Link>.
                </>
            }
            desktopDescription={
                <>
                    Уведомления об&nbsp;изменениях цены подключены. Управлять уведомлениями можно в&nbsp;разделе
                    <Link variant='primary-minor' href={savedSearchUrl} target='blank'>&laquo;Подписки&raquo;</Link>.
                </>
            }
            onClose={onClose}
        />
    );
};
